import { Helmet } from 'react-helmet';

import type { BrandingQuery } from '../../utils/branding';

type Props = {
  enabled: boolean;
  branding?: BrandingQuery;
  children: React.ReactNode;
};

/**
 * Deside to show the default funnel or wait until branding is fetched, and apply the branding to react-helmet
 */
export const BrandingWrapper: React.FC<Props> = ({ enabled, branding, children }) => {
  if (!enabled) {
    return <>{children}</>;
  }
  if (!branding) {
    return <></>;
  }
  return (
    <>
      <Helmet>
        <title>{`Shop | ${branding.name ?? 'Insify'}`}</title>
        <meta name='theme-color' content={branding.sidebarBackground ?? '#000000'} />
        <link rel='icon' href={branding.favicon.url} />
        <meta name='favicon' content={branding.favicon.url} />
      </Helmet>
      {children}
    </>
  );
};
